import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AddResolutionDTO } from '../../../../../feature/manage/player/alerts/models/alerts.model';
import { Observable } from 'rxjs';
import { DailyDepositLimitOverrideDTO } from './deposits-in-24h-threshold-override.model';

@Injectable({
  providedIn: 'root',
})
export class DepositsIn24hThresholdOverrideService {
  constructor(private http: HttpClient) {}

  public update(playerId: number, dto: DailyDepositLimitOverrideDTO): Observable<void> {
    return this.http.put<void>(`/player-activity/api/players/${playerId}/deposits-in-24h-threshold-override`, dto);
  }

  public get(playerId: number): Observable<DailyDepositLimitOverrideDTO> {
    return this.http.get<DailyDepositLimitOverrideDTO>(
      `/player-activity/api/players/${playerId}/deposits-in-24h-threshold-override`
    );
  }
}
